import { useState, useEffect } from 'react';

const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(() => {
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
			return false;
		}

		return window.matchMedia(query).matches;
	});

	useEffect(() => {
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
			return;
		}

		const media = window.matchMedia(query);
		const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

		if (typeof media.addEventListener === 'function') {
			media.addEventListener('change', handler);
			return () => media.removeEventListener('change', handler);
		}

		media.addListener(handler);
		return () => media.removeListener(handler);
	}, [query]);

	return matches;
};

export default useMediaQuery;
